import PropTypes from "prop-types";

export default function FieldSelect({ label, value, onChange, options, hint, disabled, id }) {
  return (
    <div className="rec-field">
      {label && <label htmlFor={id}>{label}</label>}
      <select
        id={id}
        className="rec-input"
        value={value ?? ""}
        disabled={disabled}
        onChange={(e) => onChange?.(e.target.value)}
      >
        {options.map((o) => {
          const v = typeof o === "object" ? o.value : o;
          const l = typeof o === "object" ? o.label : o;
          return (
            <option key={v} value={v}>
              {l}
            </option>
          );
        })}
      </select>
      {hint && <small>{hint}</small>}
    </div>
  );
}

FieldSelect.propTypes = {
  label: PropTypes.node,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
  onChange: PropTypes.func,
  options: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
      PropTypes.shape({
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
        label: PropTypes.node,
      }),
    ])
  ).isRequired,
  hint: PropTypes.node,
  disabled: PropTypes.bool,
  id: PropTypes.string,
};

FieldSelect.defaultProps = {
  label: null,
  value: "",
  onChange: undefined,
  hint: null,
  disabled: false,
  id: undefined,
};
